import { render } from "./AposTiptapButton.vue?vue&type=template&id=29b8c037"
import script from "./AposTiptapButton.vue?vue&type=script&lang=js"
export * from "./AposTiptapButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"rich-text-widget/ui/apos/components/AposTiptapButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29b8c037"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29b8c037', __exports__)) {
    api.reload('29b8c037', __exports__)
  }
  
  module.hot.accept("./AposTiptapButton.vue?vue&type=template&id=29b8c037", () => {
    api.rerender('29b8c037', render)
  })

}


export default __exports__